import { create } from 'zustand'
import type { RegistrationLocation } from '@/components/RegistrationLocationFields'
import type { ProfileLocationField } from '@/lib/profileLocation'

export interface ProfileLocationPromptRequest {
  sid: string
  location: RegistrationLocation
  missingFields: ProfileLocationField[]
}

interface ProfileLocationPromptState {
  request: ProfileLocationPromptRequest | null
  resolve: ((location: RegistrationLocation | null) => void) | null
  open: (request: ProfileLocationPromptRequest) => Promise<RegistrationLocation | null>
  finish: (location: RegistrationLocation | null) => void
}

export const useProfileLocationPromptStore = create<ProfileLocationPromptState>((set, get) => ({
  request: null,
  resolve: null,
  open: request => new Promise(resolve => {
    // A newer request replaces an unanswered one, which is treated as cancelled.
    get().resolve?.(null)
    set({ request, resolve })
  }),
  finish: location => {
    const { resolve } = get()
    set({ request: null, resolve: null })
    resolve?.(location)
  },
}))
